let sayduckScriptLoaded = false;

function initializeSayduckViewers() {
  const viewers = document.querySelectorAll('sayduck-viewer');

  if (!viewers.length) return;

  viewers.forEach(viewer => {
    if (viewer.refresh) {
      console.log("Refreshing Sayduck viewer");
      viewer.refresh();
    } else {
      console.log("Rebuilding Sayduck viewer");

      const product = viewer.getAttribute('product');
      if (!product) return;

      const attrs = {
        'product': product,
        'theme-color': '{"red":0,"green":136,"blue":206,"alpha":255}',
        'background': '#fff',
        'hide-picker': 'true',
        'hide-embed': 'true',
        'hide-product-info': 'true',
        'hide-photo-studio': 'true',
        'hide-toggle-lights': 'true',
        'hide-branding': 'false',
        'style': 'width:100%;height:600px'
      };

      const reload = document.createElement('sayduck-viewer');
      for (const [key, val] of Object.entries(attrs)) {
        reload.setAttribute(key, val);
      }

      viewer.parentNode.replaceChild(reload, viewer);
    }
  });
}

function loadSayduckScript(callback) {
  if (sayduckScriptLoaded) {
    callback();
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://viewer.sayduck.com/embed/viewer.js';
  script.type = 'module';
  script.onload = () => {
    sayduckScriptLoaded = true;
    console.log("Sayduck script loaded");
    callback();
  };
  document.body.appendChild(script);
}

// Slick support
jQuery('.productView-nav').on('init', function () {
  console.log("Slick initialized");
  loadSayduckScript(() => initializeSayduckViewers());
});

jQuery('.productView-nav').on('afterChange', function (event, slick, currentSlide) {
  console.log("Slide changed to:", currentSlide);
  initializeSayduckViewers();
});

// Fallback: No slider present
if (!jQuery('.productView-nav').hasClass('slick-initialized')) {
  loadSayduckScript(() => initializeSayduckViewers());
}
